export class TimingConstants {
    public static readonly TYPING_DELAY = 250;
    public static readonly LIST_REFRESH_INTERVAL = 5000;
    public static readonly ASYNC_RESULTS_INTERVAL = 2500;
    public static readonly TOKEN_CHECK_INTERVAL = 5000;
    public static readonly SUCCESS_MESSEGE_DELAY = 3500;

    public static readonly MS_IN_SEC = 1000;
}
